//Ook ok ok

import PropTypes from "prop-types";
import { cn } from "../../../lib/utils";
const Card = ({ title, description, photo, className }) => {
  // console.log(title, photo);
  return (
    <div
      className={cn(
        "row-span-1 rounded-xl group/bento shadow-xl transition duration-200 shadow-input dark:shadow-none bg-white   border border-gray-300  flex flex-col h-[18rem] md:w-[14rem] min-w-[16rem] max-w-[16rem] overflow-hidden ",

        className
      )}
    >
      <img src={photo} alt={title} className="h-[10rem] w-full object-cover" />

      <div className="group-hover/bento:translate-x-2 transition duration-200 p-4">
        <div className="font-sans font-semibold bg-gradient-to-tr from-base_900 to-base_500 bg-clip-text text-transparent  mb-2   border-gray-300 ">
          {title?.length > 35 ? title.substring(0, 33) + "..." : title}
        </div>

        <div
          dangerouslySetInnerHTML={{
            __html: description?.length > 70 ? description.substring(0, 70) + "..." : description,
          }}
          className="font-sans font-normal text-neutral-900 text-xs dark:text-neutral-300"
        />
      </div>
    </div>
  );
};    
export default Card;
Card.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  photo: PropTypes.string,
  className: PropTypes.string,
};
